import React from 'react';
import { Link } from 'react-router-dom';
import Text from '../text/Text'
import './styles.css';

const Footer = () => {
    return(
        <footer>
            <div id='footer-content'>
                    <Link to='/'>
                        <img src="/logo.svg" alt="Logo" style={{cursor: 'pointer'}}/>
                    </Link>
                    
                    <div className='footer-links'>
                        <Text as='p' isBold={true} fontSize={16} className='footer-titles'>Institucional</Text>
                        <div className='link-texts'>
                            <a className='footer-link' href="/pessoas">Nossa Equipe</a>
                            <a className='footer-link' href="/#doubts">Perguntas Frequentes</a>
                            <a className='footer-link' href="/sobre">Quem Somos</a>
                        </div>
                    </div>
                    <div className='footer-links'>
                        <Text as='p' isBold={true} fontSize={16} className='footer-titles'>Funcionamento:</Text>
                        <div>
                            <Text as='p' isBold={true} fontSize={16} className='footer-titles'>Endereço:</Text>
                            <Text as='p'>Escola de Administração - Avenida Reitor Miguel Calmon, s/n
                            Vale do Canela
                            Salvador/BA</Text>
                        </div>
                    </div>
                    <div className='footer-links'>
                        <Text as='p' isBold={true} fontSize={16} className='footer-titles'>Contato</Text>
                        <div id='footer-contact'>
                            <div>
                                <div className='link-icons'>
                                    <img src="/icons/mdi_email.svg" alt="email-icon" />
                                    <Text as='p'>imolab@ufba.br</Text>
                                </div>
                            </div>

                            <div className='link-icons'>
                                <Link to='https://www.instagram.com/imolab.ufba/'>
                                    <img src="/icons/Vector (1).svg" alt="instagram-icon" />
                                </Link>
                                <Link to='https://www.linkedin.com/company/imolab-ufba/'>
                                    <img src="/icons/Vector (3).svg" alt="linkedin-icon" />
                                </Link>
                            </div>
                        </div>
                    </div>
            </div>
        </footer>
    )
}

export default Footer;